module.exports = __webpack_public_path__ + "img/-LV1036k61kUQQb7aOXL.a0adf28a.jpg";